module.exports = __webpack_public_path__ + "img/IMG_1627_Black_MockedUp.398c8e0e.jpg";